import { useQuery } from "@tanstack/react-query";
import { getBundles, getProductBundles } from "../../../../services/bundle";

function useUserBundle(productId) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["bundles"],
    queryFn: getBundles,
  });

  const {
    data: productBundles,
    isLoading: isGettingProductBundles,
    error: errorGettingProductBundles,
    refetch: refetchProductBundles,
  } = useQuery({
    queryKey: ["product-bundles", productId],
    queryFn: () => getProductBundles(productId),
    enabled: !!productId,
  });

  return {
    bundles: data?.bundles || [],
    pagination: data?.pagination || {},
    isLoading,
    error,
    refetch,
    //
    productBundles: productBundles || [],
    isGettingProductBundles,
    errorGettingProductBundles,
  };
}

export default useUserBundle;
